import PortableTitle from "components/shared/PortableTitle"
import { useSizing } from "lib/helpers"
import { urlForImage } from "lib/sanity.image"
import { VerticalMediaText2 } from "schemas"
import { Container, styled, VStack } from "styled-system/jsx"
import { token } from "styled-system/tokens"

type Props = VerticalMediaText2

function Columns({
  title,
  body,
  image,

  sizingTop,
  sizingBottom,
}: Props) {
  return (
    <styled.div
      className="verticalMediaText2"
      style={
        {
          "--pt": useSizing(sizingTop),
          "--pb": useSizing(sizingBottom),
        } as React.CSSProperties
      }
      css={{
        position: "relative",
        pt: "var(--pt, 90px)",
        pb: "var(--pb, 140px)",
        color: "white",
        textAlign: "center",
        // background:
        //   "linear-gradient(90deg, rgba(24, 0, 217, .9) 24%, rgba(16, 0, 145, .9) 100%)",
        background: "rgba(31, 20, 120, 1)",
      }}>
      <Container
        css={{
          position: "relative",
          zIndex: 1,
        }}>
        <VStack gap={0}>
          <PortableTitle
            as="h3"
            altColor={token("colors.secondary.1")}
            css={{
              color: "#DFE5FF",
              fontFamily: "heading",
              fontSize: "46px",
              fontWeight: 700,
              lineHeight: "126%",
              mb: 10,
            }}>
            {title}
          </PortableTitle>
          <styled.p
            css={{
              mb: 20,
              fontSize: "22px",
              color: "#BEC9FF",
              opacity: 0.8,
            }}>
            {body}
          </styled.p>
          {image?.asset && (
            <styled.img alt={image.alt || ""} src={urlForImage(image).url()} />
          )}
        </VStack>
      </Container>
      <styled.div
        css={{
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          opacity: 0.1,
        }}>
        <styled.svg
          xmlns="http://www.w3.org/2000/svg"
          width="1440"
          height="1121"
          viewBox="0 0 1440 1121"
          fill="none"
          css={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          }}>
          <path
            d="M1656.52 -53.9702L-485.176 -53.9702L-485.176 1174.88L1656.52 1174.88V-53.9702Z"
            fill="url(#paint0_linear_553_3927)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_553_3927"
              x1="-485.176"
              y1="560.5"
              x2="1656.52"
              y2="560.5"
              gradientUnits="userSpaceOnUse">
              <stop offset="0.24" stopColor="#1800D9" />
              <stop offset="1" stopColor="#100091" />
            </linearGradient>
          </defs>
        </styled.svg>
        <styled.svg
          xmlns="http://www.w3.org/2000/svg"
          width="958"
          height="1121"
          viewBox="0 0 958 1121"
          fill="none"
          css={{
            height: "100%",
            position: "absolute",
            top: 0,
            right: 0,
          }}>
          <path
            d="M1117.42 -31.521L313.224 -31.521L501.599 154.854C647.624 299.263 647.624 535.118 501.599 679.527L0.824219 1174.88H1117.42V-31.521Z"
            fill="url(#paint0_linear_553_3928)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_553_3928"
              x1="559.166"
              y1="1174.97"
              x2="559.166"
              y2="-31.521"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#8C60FA" />
              <stop offset="0.24" stopColor="#927BFB" />
              <stop offset="0.54" stopColor="#9997FD" />
              <stop offset="0.8" stopColor="#9DA8FE" />
              <stop offset="1" stopColor="#9FAFFF" />
            </linearGradient>
          </defs>
        </styled.svg>
      </styled.div>
    </styled.div>
  )
}

export default Columns
export type { Props as VerticalMediaText2Props }
